
import React from 'react'
import { useParams } from 'react-router-dom';
import useFetchDetailsData from '../../hooks/useFetchDetailsData';
import LoadingSpinner from '../../Components/LoadingSpinner';
import ShowroomReqDetailsComponent from './ShowroomTicketRequestComponent/ShowroomReqDetailsComponent';


const ShowroomWiseRequestDetails = () => {
    const {id} = useParams()
    const { detailsData, loading, error, fetchDetailsData } = useFetchDetailsData('ccd/api/showroom-request-ticket-details-for-showroom', {id});
  
    if(loading){
        return <div><LoadingSpinner /> </div>
    }

    return (
        <ShowroomReqDetailsComponent detailsData={detailsData} />
    )
}

export default ShowroomWiseRequestDetails